<template>
  <div>
    <CRow>
      <CCol lg="12">
        <CTableWrapper :items="getUsers" :itemsPerPage="itemsPerPage">
          <template #header>
            <CIcon name="cil-grid"/> Anzahl Benutzer <strong>({{ getUsers.length }})</strong>
          </template>
        </CTableWrapper>
      </CCol>
    </CRow>
  </div>
</template>

<script>

  import CTableWrapper from './../base/UserRoleTable'
  import { mapActions, mapGetters } from 'vuex'

  export default {
    name: "List",
    components: {
      CTableWrapper
    },
    data:()=> ({
      itemsPerPage: 25

    }),
    methods: {
      ...mapActions('user', [
        'loadUsersByRole'
      ]),
      updateStatus(id, event) {
        this.setAktiv({id, event})
      },
    },

    created() {
      this.loadUsersByRole(this.$route.params.role)
    },

    computed: {
      ...mapGetters('user', [
        'getUsers'
      ])
    }
  }
</script>

<style scoped>

</style>
